import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, setupAdmin } from '../../lib/api';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { LOGO_SRC } from '../../lib/branding';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });

  useEffect(() => {
    // Check if already logged in
    const token = localStorage.getItem('admin_token');
    if (token) {
      navigate('/admin/dashboard');
    }
    
    // Setup admin on first load
    setupAdmin().catch(() => {});
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await login(credentials.username, credentials.password);
      localStorage.setItem('admin_token', response.data.access_token);
      toast.success('Login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen navy-gradient flex items-center justify-center p-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_SRC} alt="Passion of Aroma" className="h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-serif text-white">Admin Portal</h1>
        </div>

        <div className="bg-white p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="label-text">Username</Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                required
                className="input-luxury"
                placeholder="Enter username"
                data-testid="admin-username"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="label-text">Password</Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                className="input-luxury"
                placeholder="Enter password"
                data-testid="admin-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
              data-testid="admin-login-btn"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
